import { T } from 'gt-react';
import { useArShortPayRecommendations } from '@/api/rpc/hooks/accounts-receivable/useArShortPayRecommendations';
import { CollectionRecommendationCard } from './CollectionRecommendationCard';

interface Props {
  threadId: string;
  onDraftEmail: (seed: {
    initialPrompt: string;
    initialToRecipients?: string[];
  }) => void;
}

/**
 * Short-pay recommendation card — a thin binding of the shared
 * CollectionRecommendationCard to the short-pay recommendations hook.
 */
export function ShortPayRecommendationCard({ threadId, onDraftEmail }: Props) {
  const recommendations = useArShortPayRecommendations(threadId);

  return (
    <CollectionRecommendationCard
      onDraftEmail={onDraftEmail}
      emptyState={
        <T context="empty state, no short-pay recommendation yet">
          No recommendation yet. It generates automatically for new short pays —
          use Regenerate if it hasn't appeared.
        </T>
      }
      {...recommendations}
    />
  );
}
